import { stringSimilarity } from 'string-similarity-js';
import { resetFilter } from '../../ProjectFilters';

/**
 * Searching through given search term attributes of list items for given search string and return findings
 *
 * @param searchString
 * @returns {null}
 */
export function findInSearchTerms(searchString) {
  const items = document.querySelectorAll('#js-org-interactive-map-projects-list [data-filter-search-term]');
  let bestMatch = null;
  let bestScore = 0;

  /* eslint-disable no-plusplus */
  for (let i = 0; i < items.length; i++) {
    const term = items[i].dataset.filterSearchTerm;
    const score = stringSimilarity(searchString, term);

    if (score > bestScore && items[i].dataset.filterSearchTerm !== '') {
      bestScore = score;
      bestMatch = items[i];
    }
  }

  return bestScore >= 0.6 ? bestMatch : null;
}

/**
 * Find location, post code or address by given search text
 *
 * @param view - View where the search will be executed and routes to location
 * @param text - Search text (location, post code or address)
 * @param viewRadiusMeters - circle radius of a finding location point as default ~ 10km (10000m)
 * @returns {Promise<void>} - proceed function
 */
export async function findInLocations(view, text, viewRadiusMeters = 10000) {
  if (!text) {
    return;
  }

  window.require([
    'esri/Graphic',
    'esri/geometry/Circle',
  ], (Graphic, Circle) => {
    const url = 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates';
    const params = new URLSearchParams({
      f: 'json',
      SingleLine: `${text} Deutschland`,
      maxLocations: 1,
      countryCode: 'DE',
    });

    try {
      fetch(`${url}?${params.toString()}`)
        .then(r => r.json())
        .then((data) => {
          if (!data.candidates || data.candidates.length === 0) {
            console.warn('Keine Treffer');
            return;
          }

          const best = data.candidates[0];
          const circle = new Circle({
            center: best.location,
            radius: viewRadiusMeters,
            radiusUnit: 'meters',
            geodesic: true,
          });

          const graphic = new Graphic({
            geometry: circle,
            symbol: {
              type: 'simple-fill',
              width: viewRadiusMeters,
              height: viewRadiusMeters,
              color: [62, 0, 49, 0.1],
              outline: {
                color: [30, 0, 25, 0.5],
                width: 3,
              },
            },
          });

          view.graphics.removeAll(); view.graphics.add(graphic);
          view.goTo(circle.extent.expand(1.2));
        });
    } catch (error) {
      console.warn('Fehler bei Ortssuche:', error);
    }
  });
}

/**
 * Resets the graphic (circle) in the view area, reset filter chips and clears input field
 *
 * @param view
 */
export function resetSearchInput(view) {
  const parent = document.getElementById('js-project-search-from');
  const input = parent.querySelector('#js-project-search-input');

  input.value = '';
  view.graphics.removeAll();
  resetFilter();
}
